// [5.1] HotelFormStep1AA.jsx – property‑type selector
import React,{useState,useEffect}from "react";
import {FaHotel,FaHome,FaUmbrellaBeach,FaCoffee,FaBed,FaBuilding} from "react-icons/fa";
export default function HotelFormStep1AA({hotelData,setHotelData,setCanProceedStep1}){
  const facilityTypes=["Hotel","Guest House","Resort","Bed & Breakfast","Hostel","Apartment"];
  const facilityIcons={Hotel:<FaHotel/>,"Guest House":<FaHome/>,Resort:<FaUmbrellaBeach/>,"Bed & Breakfast":<FaCoffee/>,Hostel:<FaBed/>,Apartment:<FaBuilding/>};
  const[selectedFacility,setSelectedFacility]=useState(hotelData.Type||"");
  const handleSelect=t=>{
    if(selectedFacility===t){setSelectedFacility("");setHotelData(p=>({...p,Type:""}));setCanProceedStep1(false);}else{setSelectedFacility(t);setHotelData(p=>({...p,Type:t}));setCanProceedStep1(true);} };
  useEffect(()=>{setSelectedFacility(hotelData.Type);setCanProceedStep1(!!hotelData.Type);},[hotelData.Type,setCanProceedStep1]);
  return(
    <div className="hotel-form-step1aa-container">
      <h2>Please select the Type of Property you want to Register</h2>
      <div className="facility-options">
        {facilityTypes.map(t=>(
          <button key={t} className={`facility-option ${selectedFacility===t?"selected":""}`} onClick={()=>handleSelect(t)} aria-pressed={selectedFacility===t}>
            <div className="icon-container">{facilityIcons[t]}</div><span className="facility-name">{t}</span>
          </button>))}
      </div>
      {selectedFacility&&<p className="success-message">You have selected: {selectedFacility}</p>}
    </div>);
}